import { ownerForEnqueue } from './queueOwner';
import { sealUnownedOperations as sealSimple } from './offlineQueue';
import { sealUnownedOperations as sealCompound } from './offlineCompoundQueue';
import { sealUnownedOperations as sealImages } from './offlineImageUploadQueue';

/**
 * Sella con el dueño de la sesión que sale todo lo encolado sin dueño, en las
 * tres colas (spec 2026-10-12).
 *
 * El logout ya no borra las colas: lo que tiene dueño solo lo envía su dueño
 * (#331). Lo encolado antes de la #331 no lo tiene, y eso lo envía cualquier
 * sesión: sin sellarlo, el siguiente operario lo mandaría con su token y a su
 * tenant. Va con la sesión todavía viva (`ownerForEnqueue`: la actual o, si ya
 * no la hay, la última conocida). Devuelve cuántas operaciones selló.
 */
export async function sealUnownedQueuedWork(): Promise<number> {
  const owner = ownerForEnqueue();
  if (!owner) return 0;
  const sealed = await Promise.all([sealSimple(owner), sealCompound(owner), sealImages(owner)]);
  return sealed.reduce((total, count) => total + count, 0);
}
